import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../config';
import { CidSummary } from '../features/app/context/device-sidebar/containers/CidSummaryContainer';

export const connectedVehiclesApi = createApi({
    reducerPath: 'connectedVehicles',
    tagTypes: ['ConnectedVehicles'],
    baseQuery: fetchBaseQuery({
        baseUrl: config.backend.CONNECTED_VEHICLES_SERVICE
    }),
    endpoints: (builder) => ({
        fetchCidSummary: builder.query<CidSummary[], {originator: string}>({
            query: ({ originator }) => ({
                url: `/cid-summary/${originator}`,
                responseHandler: async (response: Response) => response.json(),
                providesTags: ['ConnectedVehicles'],
            }),
        }),
    }),
});

export const { useFetchCidSummaryQuery } = connectedVehiclesApi;